import { call } from '../core'

export interface IChangeStatusBarParams {
  backgroundColor: string // #FF0000
}

export function changeStatusBar(params: IChangeStatusBarParams) {
  call('finChangeStatusBar', params)
}
